import React from "react";
import { Brain } from "lucide-react";
import { useAuth, isAdmin } from "../contexts/AuthContext";
import { can } from "../lib/permissions";
import { SuggestedFilm } from "./iq/SuggestedFilm";
import { MiniCourses } from "./iq/MiniCourses";

// IQ tab: auto/coach Mini Courses + hand-picked Film Study. (IQ course assignments retired 2026-06 — videos live in the libraries / Film Database.)
export default function PlayerIQ({ playerId }) {
  const { user } = useAuth();
  const canEdit = isAdmin(user);
  return (
    <section className="space-y-4" data-testid="player-iq-tab">
      <div className="flex items-center gap-2">
        <Brain className="w-5 h-5 text-[var(--org-accent)]" />
        <div>
          <h2 className="font-heading uppercase text-2xl tracking-[0.2em] text-white">IQ · Online Learning</h2>
          <div className="text-[10px] uppercase tracking-[0.4em] text-[#a0a0a0] mt-0.5">Mini courses · Film Study · self-paced</div>
        </div>
      </div>
      {can(user, "iq.mini_courses") && <MiniCourses playerId={playerId} canEdit={canEdit} />}
      {can(user, "iq.suggested_film") && <SuggestedFilm playerId={playerId} canEdit={canEdit} />}
    </section>
  );
}
